<template>
	<div class="contentTab">
<!--		:filtersList="safetyStatementsFilterList"-->
		<main-table
				v-if="safetyStatementsFilterList"
				:flag="flag"
				text-create="Create statement"
				page-title="Safety statements"
				:headers="headers"
				:listItems="safetyStatementsList"
				:filtersList="safetyStatementsFilterList"
				:uniqId="uniqId"
				@updateClickButton="onClickButton"
				@updateCreate="onCreate(true)"
				@updateSearch="onFilter"
				@updateRefreshFilters="onFilter"
				@updateChangeSort="onFilter"
				@updateExport="onExport"
				@updateSettings="onSettingsOpen"
				:isExport="isExport()"
				is-export-permissions
				:department_id="user.department_id"

				:isCreate="false"
		></main-table>
		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave('safety-statement')"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="getSettings"
		></table-settings>

		<safety-statements-create
				v-if="isCreateStatements"
				@updateClose="onCreate(false)"
				@updateView="onView(true)"
		></safety-statements-create>

<!--		@updateCloseViewDialog="onView(true)"-->
		<safety-statements-view
				v-if="isSafetyStatementsView"
				@updateCloseViewDialog="onView(false)"
		></safety-statements-view>
		<remove-block
				v-if="isRemove"
				:preloader="loading"
				@updateRemoveItem="onRemoveItem"
				@updateRemoveClose="onRemoveClose"
		></remove-block>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
const SafetyStatementsCreate = () => import('@/components/Accounting/SafetyStatements/SafetyStatementsCreate/SafetyStatementsCreate');
const SafetyStatementsView = () => import('@/components/Accounting/SafetyStatements/SafetyStatementsView/SafetyStatementsView');
const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");
// constants
// import { PERMISSIONS } from "@/constants/constants";
// mixins
import settingsMixins from "@/mixins/settingsMixins";
import { PERMISSIONS, TAB } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "StatementsSafety",
	mixins: [ settingsMixins ],
	components: {
		SafetyStatementsCreate,
		SafetyStatementsView,
		RemoveBlock
	},
	props: {
		id: [ String, Number ],
		isGeneralTitle: {
			type: Boolean,
			default: true,
		},
		textGeneralTitle: {
			type: String,
			default: "Statements Items",
		},
		user: Object,
	},
	computed: mapGetters([
		'customers',
		'safetyStatementsList',
		'safetyStatementsFilterList',
		'linksPermissions',
		'permissions',
		'permissionsDefault',
	]),
	data: () => ({
		flag: TAB.USER_TAB_ST_ST__SAFETY,
		refreshFilters: false,
		isRemove: false,
		loading: false,
		isCreateStatements: false,
		isSafetyStatements: false,
		isSendSafetyStatements: false,
		isDrawerSafetyStatements: false,
		isSafetyStatementsView: false,
		dataActions: null,
		editRow: null,
		uniqId: null,
		link: null,
	}),
	methods: {
		...mapActions([
			'getSafetyStatementsListUser',
			'createSchedule',
			'onEditSchedule',
			'setWarning',
			'onSafetyStatementsFilterUser',
			'onExportLink',
			'onRemoveSafetyStatements',
			'onSafetyStatementsCreate',

		]),
		isExport() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_ST_TS, PERMISSIONS.EXPORT ];
			return getPermissionsMod({ list, path });
		},
		async onEdit({ line }) {
			// if (this.permissions[PERMISSIONS.EDIT] || this.permissions[PERMISSIONS.VIEW]) {
			this.itemId = line.id;
			this.isSafetyStatements = true;
			// }
		},
		async onClickButton({ key, item }) {
			if (key === "openLoads") {
				// if (this.permissions[PERMISSIONS.EDIT] || this.permissions[PERMISSIONS.VIEW] || this.permissions[PERMISSIONS.CREATE_EDIT_TRIP]) {
				await this.onSafetyStatementsCreate(item);
				this.isSafetyStatementsView = true;
				// }
			}
			if (key === "delete") {
				this.removeId = item.id;
				this.isRemove = true;
			}
		},
		async onRemoveItem() {
			this.loading = true;
			await this.onRemoveSafetyStatements(this.removeId);
			this.isRemove = false;
			this.loading = false;
		},
		onRemoveClose() {
			this.isRemove = false;
		},
		onCreate(value) {
			if (!value) this.itemId = null;
			this.isCreateStatements = value;
		},
		onView(value) {
			this.isSafetyStatementsView = value;
		},
		async onExport(values) {
			values.id = this.id;
			values.setting = [
				"id",
				"created_by",
				"month",
				"salary",
				"bonus",
				"total",
			];
			await this.onExportLink({ values, requestKey: 'safety-statement', isSetting: 1 });
		},
		async onFilter(info) {
			// await this.onSafetyStatementsFilterUser(info.filterModList);
			const id = this.id;

			if (!info.filterModList) {
				info.filterModList = {}; // создаем объект, если его нет
			}

			// Проверяем, есть ли в filterModList массив filter_dispatcher_name
			if (Array.isArray(info.filterModList.filter_employee)) {
				// Если массив существует, добавляем id в него
				info.filterModList.filter_employee.push(id);
			} else {
				// Если массива нет, создаем его с id
				info.filterModList.filter_employee = [ id ];
			}

			// Выполняем обновление фильтра
			await this.onSafetyStatementsFilterUser(info.filterModList);
		},
	},
	async created() {
		// await this.getSafetyStatementsListUser();
		// { filter_employee: [92] }
		const id = this.id;
		await this.onSafetyStatementsFilterUser({ filter_employee: [ id ] });

	}
};
</script>

<style scoped lang="scss"></style>
